// extracted by mini-css-extract-plugin
export default {"BrowseMode":"BrowseMode_BrowseMode__SU8SN"};